import React from "react";

export const Card = ({ title, extra, children, testid, className = "", color = "#065f46" }) => (
  <div className={`rounded-xl border bg-white p-4 ${className}`} data-testid={testid}>
    <div className="flex items-center justify-between gap-2 mb-2 flex-wrap"><div className="text-[11px] font-extrabold uppercase tracking-wider" style={{ color }}>{title}</div>{extra}</div>
    {children}
  </div>
);

export const KV = ({ rows }) => rows.map(([k, v]) => (
  <div key={k} className="flex justify-between gap-3 text-sm py-1.5 border-t first:border-0"><span className="text-slate-500 shrink-0">{k}</span><b className="font-semibold text-right break-words">{v || "—"}</b></div>
));

export const Pill = ({ on, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} className={`px-3 py-1.5 rounded-full text-xs font-bold border transition-colors ${on ? "bg-emerald-800 text-white border-emerald-800" : "bg-white text-slate-600 hover:bg-emerald-50"}`}>{children}</button>
);

export const Tiles = ({ items, testid }) => (
  <div className={`grid grid-cols-2 gap-2 ${items.length === 5 ? "md:grid-cols-5" : items.length > 3 ? "md:grid-cols-4" : "md:grid-cols-3"}`} data-testid={testid}>
    {items.map(([t, v, s, c, warn]) => (
      <div key={t} className={`rounded-lg px-3 py-2 ${warn ? "ring-1" : ""}`} style={{ background: `${c}10`, "--tw-ring-color": `${c}66` }}>
        <div className="text-[11px] font-bold uppercase" style={{ color: c }}>{t}</div>
        <b className="text-lg tabnum block leading-tight" style={{ color: c }}>{v}</b>
        <div className="text-[10px] text-slate-500 truncate">{s || "\u00a0"}</div>
      </div>
    ))}
  </div>
);

export const Banner = ({ color, bg, border, Icon, title, sub, children, testid }) => (
  <div className="rounded-xl border-2 p-4 flex items-center gap-4 flex-wrap" style={{ background: bg, borderColor: border }} data-testid={testid}>
    <span className="w-10 h-10 rounded-full text-white grid place-items-center shrink-0" style={{ background: color }}><Icon size={18} /></span>
    <div className="flex-1 min-w-[160px]"><b className="font-head text-lg" style={{ color }}>{title}</b><div className="text-sm" style={{ color }}>{sub}</div></div>
    {children}
  </div>
);
